<template>
  <div class="forms">
        <b-container fluid >
            <b-row  class="mycontainer-main " >
                <b-col cols="12" md="4" class="pl-5 leftcontent" >
                    <h6 class="my-0" style="color: grey"> {{$t('common.form')}} </h6>  
                    <h2>{{destinationForm | capitalize}}</h2>               
                    <br>                                      
                    <h1 v-if="this.destinationForm == 'covid19'" style="font-weight: 900; font-size: 1.9em;">Questionnaire de préparation</h1>
                    <h1 v-if="this.destinationForm == 'intake'"style="font-weight: 900; font-size: 1.9em;">Questionnaire de préparation</h1>
                    <!-- <b-button squared variant="outline-dark" class="mt-3"  @click="goBack"> {{ $t('common.goback') }} </b-button>   -->
                </b-col>

                <b-col cols="12" md="6" class="align-self-center py-3" id="apptform" v-if="!submitComplete">

                
                    <FormCovid v-if="this.destinationForm == 'covid19'"/>
                    <FormIntake v-if="this.destinationForm == 'intake'"/>

                </b-col>
                <b-col v-if="submitComplete" cols="12" md="6" class="align-self-center py-3">
                    <b-card>
                        <b-card-title>{{ $t('requestappt.submitted') }}</b-card-title>
                    </b-card>
                </b-col>
           </b-row>
        </b-container>
  </div>
</template>

<script>

import FormCovid from '@/components/FormCovid'
import FormIntake from '@/components/FormIntake'

export default {
  name: 'forms',
  components: {
      FormCovid,
      FormIntake
  },
  data () {
    return {
      msg: 'Welcome to BI',
      show: true,
      display: '',
      submitComplete: false,
      destinationForm: this.$route.params.name

    }
  },
  methods: {
    goBack(){
    this.$router.go(-1)
  },
  },
filters: {
  capitalize: function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  }
}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
    min-height:  calc(90vh);
}
/* .mycontainer-main2 {
    min-height: 10vh ;
} */
.m-borders{
    border: 3px solid white
}

#clinicservices .card-columns {
    column-count: 2;
}
@media (max-width: 576px) {
    #clinicservices .card-columns {
        column-count: 1;
    }
}
.leftcontent {
    padding-top: 30vh;
    padding-bottom: 10vh;
}
.card-img-top {
    width: 100%;
    height: 20rem;
    object-fit: cover;
}
h4 {
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/Forms.vue